import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
    SlackNotificationOptionalParameters,
    SlackNotificationService,
    SlackNotificationTypes
} from '../../core-services/SlackNotification.service';
import { InitDataService } from '../../system-services/InitData/InitData.service';
import { ModuleAccessService } from '../../system-services/ModuleAccess/ModuleAccess.service';
import { TranslationService } from '../../translations';

/**
 * @deprecated Use upgrade-account component.
 */
@Component({
    selector: 'chilipiper-calendar-button',
    template: `
        @if (showUpgradeButton()) {
            <button
                [ngClass]="getButtonClass()"
                (click)="bookUpgradeAppointment()"
            >
                {{ TR.key(getButtonText()) }}
            </button>
        }
    `,
    standalone: false
})
export class ChiliPiperComponent {
    @Input()
    requestFromPaywall = false;

    @Output()
    buttonClicked: EventEmitter<void> = new EventEmitter();

    constructor(
        private init: InitDataService,
        public TR: TranslationService,
        private moduleAccess: ModuleAccessService,
        private slackNotification: SlackNotificationService
    ) {}

    bookUpgradeAppointment(): void {
        const location = this.requestFromPaywall
            ? 'value metrics paywall'
            : 'header upgrade button';

        // If requesting from somewhere else, (different set of calendars) change the second paramater ('ss_requstdemo') to match new inboud router

        (window as any).ChiliPiper.submit('predictiveindex', 'ss_requestdemo', {
            closeOnOutside: true,
            title: 'Unlock more teams?',
            titleStyle: 'color: black, font-size: 35px;',
            injectRootCss: true,
            map: true,
            lead: {
                FirstName: this.init.user.firstName,
                LastName: this.init.user.lastName,
                Email: this.init.user.email,
                Lead_Type__c: 'Request Demo',
                Lead_Type_History__c: 'Request Demo',
                Hubspot_Lead_Source__c: `SelfServe - ${location}`,
                Original_Lead_Source_History__c: `SelfServe - ${location}`
            },
            onSuccess: () => {
                this.postSlackCelebration();
            }
        });
        this.buttonClicked.emit();
    }

    postSlackCelebration() {
        const slackParameters = new SlackNotificationOptionalParameters({
            location: location.toString()
        });
        this.slackNotification.callNotificationWebhook(
            SlackNotificationTypes.MeetingBooked,
            slackParameters
        );
    }

    getButtonClass(): string {
        return this.requestFromPaywall
            ? 'button button-md button-primary'
            : 'button button-transparent button-sm';
    }

    getButtonText(): string {
        return this.requestFromPaywall
            ? 'value-metrics.modal.self-serve.schedule-call'
            : 'teamDiscovery.upgrade-account';
    }

    showUpgradeButton(): boolean {
        // This is replaced by the upgrade account component
        return false;
    }
}
